import { Routes } from '@angular/router'
import { UserRolesConditionEnum, UserRolesEnum } from '@ui-core/enums/user-roles.enum'
import { authGuard } from '@ui-core/guards/auth.guard'
import { featureRoles } from '@ui-core/utils/role-resolver'

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('@ui-features/home/home').then((m) => m.Home),
    },
    {
        canActivate: [authGuard],
        path: 'dashboard',
        loadComponent: () => import('@ui-features/kermit-dashboard/kermit-dashboard').then((m) => m.KermitDashboard),
        data: {
            permission: {
                roles: [...featureRoles('Chat_History', 'Health_Dashboard'), UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'health',
        loadComponent: () => import('@ui-features/kermit-health/kermit-health').then((m) => m.KermitHealth),
        data: {
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'health/orders',
        loadComponent: () =>
            import('@ui-features/kermit-health/kermit-health-orders').then((m) => m.KermitHealthOrders),
        data: {
            menuActive: 'health',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'health/spread-requests',
        loadComponent: () => import('@ui-features/kermit-health/kermit-health-rfs').then((m) => m.KermitHealthRfs),
        data: {
            menuActive: 'health',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'metrics/quick-actions',
        loadComponent: () =>
            import('@ui-features/kermit-quick-actions/kermit-quick-actions').then((m) => m.KermitQuickActions),
        data: {
            menuActive: 'health',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'chats',
        loadComponent: () => import('@ui-features/kermit-chats/kermit-chats').then((m) => m.KermitChats),
        data: {
            permission: {
                roles: featureRoles('Chat_History'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'admin',
        loadComponent: () => import('@ui-features/admin/admin').then((m) => m.Admin),
        data: {
            permission: {
                roles: [UserRolesEnum.Ballance_Admin],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'monitor/session-insights',
        loadComponent: () => import('@ui-features/session-insights/session-insights').then((m) => m.SessionInsights),
        data: {
            menuActive: 'monitor',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'monitor/reports',
        loadComponent: () => import('@ui-features/monitor-reports/monitor-reports').then((m) => m.MonitorReports),
        data: {
            menuActive: 'monitor',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'monitor/reports/:reportId',
        loadComponent: () =>
            import('@ui-features/monitor-reports/monitor-report-detail').then((m) => m.MonitorReportDetail),
        data: {
            menuActive: 'monitor',
            permission: {
                roles: featureRoles('Health_Dashboard'),
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'deepeval/runs',
        loadComponent: () => import('@ui-features/deepeval/deepeval-runs').then((m) => m.DeepEvalRuns),
        data: {
            menuActive: 'deepeval',
            expandMenu: false,
            permission: {
                roles: [UserRolesEnum.Ballance_Admin, UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'deepeval/runs/new',
        loadComponent: () => import('@ui-features/deepeval/deepeval-new-run').then((m) => m.DeepEvalNewRun),
        data: {
            menuActive: 'deepeval',
            expandMenu: false,
            permission: {
                roles: [UserRolesEnum.Ballance_Admin, UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'deepeval/runs/:runId',
        loadComponent: () => import('@ui-features/deepeval/deepeval-run-detail').then((m) => m.DeepEvalRunDetail),
        data: {
            menuActive: 'deepeval',
            expandMenu: false,
            permission: {
                roles: [UserRolesEnum.Ballance_Admin, UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: 'deepeval/runs/:runId/results/:agent/:testName',
        loadComponent: () => import('@ui-features/deepeval/deepeval-test-detail').then((m) => m.DeepEvalTestDetail),
        data: {
            menuActive: 'deepeval',
            expandMenu: false,
            permission: {
                roles: [UserRolesEnum.Ballance_Admin, UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        canActivate: [authGuard],
        path: '**',
        loadComponent: () => import('@ui-features/error/error').then((m) => m.Error),
    },
]
